module.exports = __webpack_public_path__ + "img/28.a6ef90b0.jpeg";